import AnimationClip from '../AnimationClip';
import { Tween, Easing } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import ElementComponent from '../../../Component/UI/Element';

export class TopList extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const element: ElementComponent = gameObject.getComponent(
            ElementComponent
        );

        element.layout.pivot[0] = 1;

        const tween: Tween = this.getTween(element.layout.pivot);

        tween.to({ 0: 0 }, 300).easing(Easing.Quadratic.InOut);

        yield* this.startTween(tween);
    }
}
